import {
  IAuditFormsClosingCloseResponse,
  IAuditFormsClosingOpenResponse
} from 'types/auditFormsClosings';
import request from './index';
import toErrorWithMessage from 'utilities/getErrorMessage';

export const closeAuditFormClosing = async (id: number | string) => {
  try {
    return await request<IAuditFormsClosingCloseResponse>({
      options: {
        url: `/audit_forms_closings/${id}/close`,
        method: 'patch'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};

export const openAuditFormClosing = async (id: number | string) => {
  try {
    return await request<IAuditFormsClosingOpenResponse>({
      options: {
        url: `/audit_forms_closings/${id}/open`,
        method: 'patch'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};
